import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AgeStore {

}

export enum AgeStoreKeys {

}
